function initRecoverEbookForm() {
  const form = document.querySelector('.js-recover-ebook-form')
  const btnSubmit = form.querySelector('.submit-recover-btn')
  const btnSubmitText = btnSubmit.querySelector('.submit-recover-btn-text')
  const btnSubmitSpinner = btnSubmit.querySelector('.submit-recover-btn-spinner')
  form.addEventListener('submit', (e) => {
    btnSubmit.disabled = true
    btnSubmitText.classList.add('d-none')
    btnSubmitSpinner.classList.remove('d-none')
  })
}

initRecoverEbookForm();
